import { render, staticRenderFns } from "./value.vue?vue&type=template&id=ad3f8a4e&scoped=true&"
import script from "./value.vue?vue&type=script&lang=js&"
export * from "./value.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3f8a4e",
  null
  
)

export default component.exports